(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            views: {
                'content@': {
                    templateUrl: 'app/layouts/public/public.html',
                    controller: 'PublicController',
                    controllerAs: 'vm'
                }
            },
            parent: 'app'
        });
    }
})();
